import { render } from "./App.vue?vue&type=template&id=4089af54&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4089af54&scoped=true&lang=css"

import exportComponent from "/home/vestment25/upgrading/jarvis-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4089af54"]])

export default __exports__